import * as React from 'react';
import { QuestionCatalogueDto } from '../../../pages/questionCatalogue/qustionCatalogueTypes';
import { translation } from '../../../i18n';
import QuestionModule from './QuestionModule';
import { AnsweredCatalogueDto } from '../../../pages/answeredCatalogueTypes';
import moment from 'moment';
import Catalogue from '../common/Catalogue';
import { observer } from 'mobx-react';

interface Props {
  questionCatalogue: QuestionCatalogueDto,
  answeredCatalogueDto: AnsweredCatalogueDto,
  endDate: string,
  updateAnsweredCatalogue: (updatedCatalogue: AnsweredCatalogueDto) => void
}

interface State {
  activeStep: number,
}

@observer
class QuestionCatalogue extends React.Component<Props, State> {
  public state = {
    'activeStep': 0,
  };

  constructor(props: Props) {
    super(props);
    this.renderModule = this.renderModule.bind(this);
  }

  public render() {
    return (
      <Catalogue
        modules={this.props.questionCatalogue.modules}
        finishPage={{
          head:translation.t('questionCatalogueComponent.title'),
          body:translation.t('questionCatalogueComponent.body', {date: moment(this.props.endDate).format('DD.MM.YYYY')})
        }}
        renderModule={this.renderModule}/>
    )
  }

  private renderModule(activeStep: number) {
    return (
      <QuestionModule key={this.props.questionCatalogue.modules[activeStep].id}
                      updateAnsweredCatalogue={this.props.updateAnsweredCatalogue}
                      questionModule={this.props.questionCatalogue.modules[activeStep]}
                      answeredCatalogueDto={this.props.answeredCatalogueDto}/>
    )
  }

}

export default QuestionCatalogue;
